<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img8_2-1" src="images/img8_2-1.jpg"/></p>
<p class="caption">Seventh Regiment, Illinois National Guard, Chicago leaving for camp with their women seeing them off. 5US and inset 5USa</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01d-a_AMERICAN_EXPEDITIONARY_FORCE.vue?012a57b4